import PropTypes from 'prop-types';
import { Link } from 'dibs-elements/exports/Link.tsx';

import { ALPHA_TITLE_ID } from '../constants/sitemapConstants.js';

import styles from '../styles/alphaNavigation.scss';

export const SitemapAlphaNavigation = ({ items }) => {
    return (
        <ul className={styles.alphaNav}>
            {items.map(item => {
                const keyLink = `#${ALPHA_TITLE_ID}${item.title}`;
                return (
                    <li className={styles.alphaLinkWrapper} key={keyLink}>
                        <Link href={keyLink} className={styles.alphaLink}>
                            {item.title.toUpperCase()}
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
};

SitemapAlphaNavigation.propTypes = {
    items: PropTypes.array,
};
